/** Full starred-lists list (shell route `/starred-lists`): all lists the hook loaded, with delete. */
import React from 'react';
import { SAVED_LISTS_LIMIT, useSavedLists } from '../hooks/useSavedLists';
import { SavedListRow } from '../shell/home/SavedListRow';
import { useTab } from '../shell/TabContext';
import { relativeTime } from '../utils/describeSearch';
import { handOffSavedList, savedListPath } from '../utils/searchNav';

/** The lists themselves (limit note, empty state, rows with delete) — shared
 *  by this page and the Account page's "Starred lists" section. */
export const StarredListsBody: React.FC = () => {
  const { lists, isLoading, deleteList } = useSavedLists();
  const { storageKey } = useTab();
  return (
    <>
      {!isLoading && lists.length === SAVED_LISTS_LIMIT && (
        <p className="mt-1 text-[12px] text-ink-3">{`Showing your latest ${SAVED_LISTS_LIMIT}`}</p>
      )}
      {!isLoading && lists.length === 0 && <p className="mt-4 text-[13px] text-ink-3">No starred lists yet.</p>}
      <div className="mt-4">
        {lists.map((l) => (
          <SavedListRow
            key={l.id}
            list={l}
            to={savedListPath(l)}
            replace={false}
            onBeforeNavigate={() => handOffSavedList(l, storageKey)}
            meta={relativeTime(l.created_at)}
            trailing={
              <button
                type="button"
                aria-label="Delete list"
                data-testid={`starred-delete-${l.id}`}
                className="text-ink-3 hover:text-ink"
                onClick={() => { if (window.confirm(`Delete starred list "${l.name}"?`)) deleteList(l.id); }}
              >
                <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            }
          />
        ))}
      </div>
    </>
  );
};

const StarredListsPage: React.FC = () => (
  <div data-testid="starred-lists-page" className="mx-auto w-full max-w-3xl p-8">
    <h1 className="font-display text-[28px] font-medium tracking-[-0.02em] text-ink">Starred lists</h1>
    <StarredListsBody />
  </div>
);

export default StarredListsPage;
